module.exports = __webpack_public_path__ + "img/zfcg.24348f8.jpg";